import { apiGet, apiPut } from '../helpers/ApiHelper';
import Auth from 'j-toker';

export function getData() {
  return dispatch => {
    return apiGet(Auth.getApiUrl() + `/landlords/dashboard/`)
      .done(response => {
        dispatch(receiveData(response.data));
      })
      .catch(error => {
        console.error(error);
      });
  };
}

export function getGraphData() {
  return dispatch => {
    return apiGet(Auth.getApiUrl() + `/landlords/dashboard_graphs/`)
      .done(response => {
        dispatch(receiveGraphData(response.data));
      })
      .catch(error => {
        console.error(error);
      });
  };
}

export function receiveGraphData(data) {
  return {
    type: 'DASHBOARD::RECEIVE_GRAPH_DATA',
    data,
  };
}

export function receiveData(data) {
  return {
    type: 'DASHBOARD::RECEIVE_DATA',
    data,
  };
}

export function getDuplicateTenants() {
  return dispatch => {
    return apiGet(Auth.getApiUrl() + `/landlords/dashboard_duplicate_tenants/`)
      .done(response => {
        dispatch({
          type: 'DASHBOARD::DUPLICATE_LEADS',
          duplicateTenants: response.duplicate_tenants,
        });
      })
      .catch(error => {
        console.error(error);
      });
  };
}

export function updateDuplicateTenant(id, options) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + '/landlords/duplicate_tenants/' + id, options)
        .done(response => {
          dispatch(getDuplicateTenants());
        })
        .catch((error, textStatus) => {
          console.error(textStatus);
          return error;
        }),
    });
  };
}
